var $ = require( "jquery" );
window.jQuery = $; window.$ = $;
// import ModalVideo from 'modal-video';
// import { TimelineMax } from "gsap";
import slick from 'slick-carousel';
// import MiniMasonry from "minimasonry";
import Macy from "macy";

if($(".masonry").length) {
	var macy = Macy({
	    container: '.masonry',
	    trueOrder: true,
	    waitForImages: false,
	    margin: 24,
	    columns: 2,
	    breakAt: {
	        767: 1,
	    }
	});
}


(function() {

  function elSlider() {
	  	if ($('.carousel').length) {
	  		$('.carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
				var i = (currentSlide ? currentSlide : 0) + 1;
				$('.carousel-current').text( i + ' of ' + slick.slideCount);
			}).slick({
		          dots : false,
		          infinite: true,
		          slidesToShow: 1,
		          arrows: true,
		          fade: true,
		          prevArrow : '.control.prev',
		          nextArrow : '.control.next',
		          adaptiveHeight: true,
		      });
	  	}
  }
  elSlider();

  function slideMe(name, totalSlideToShow) {
  	if ($(name).length) {
	  	$(name).each(function(key, item) {
	  		var id = $(this).attr("id");
	  		var sliderId = '#' + id;
	  		var arrowPrev = '#' + id + ' + div .prev';
	  		var arrowNext = '#' + id + ' + div .next';

	  		// alert(arrowNext);

	  		$(sliderId).on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// $('.title-h2 > div').fadeOut();
			}).on('afterChange', function(event, slick, currentSlide, nextSlide){
				// $('.title-h2 > div').fadeIn();
			}).slick({
				  appendDots : ".pagination",
				  dots : true,
		          infinite: true,
		          //slidesToShow: totalSlideToShow,
							slidesToShow: 3,
							centerMode: true,
							centerPadding: '20%',
		          waitForAnimate: false,
		          arrows: true,
		          fade: false,
		          prevArrow : (arrowPrev),
		          nextArrow : (arrowNext),
		          adaptiveHeight: true,
		          swipe: true,
		          swipeToSlide: true,
		          edgeFriction: 0,
		          touchThreshold: 4,
		          touchMove: true,
		          responsive: [
			      		{
			      			breakpoint: 960,
			      			settings: {
			      				slidesToShow: 2
			      		}
		          	},
		          	{
			      			breakpoint: 599,
			      			settings: {
			      				slidesToShow: 1
			      		}
		          	},
		          ]
			});
	  	});
  		}
	}

	slideMe('.slider', 2);
	slideMe('[class*="slider"]', 4);


	/* Mobile menu */
	$('.menu-icon').click(function() {
	  $(this).toggleClass('on');
	  $('.mobile-menu').slideToggle();
	  $('body').toggleClass('overflow active-nav');
	  $('header .logo').toggleClass('off');
	});

	$('.mobile-menu').find('.icon-toggle').click(function() {
	  $(this).parent().toggleClass('on');
	  $(this).next('ul').slideToggle();
	});

	$('.search.btn, .search-icon').click(function() {
		$('.modal').slideToggle(300);
		$('.menu-dropdown-wrap > ul').toggleClass('on');
		$(this).toggleClass('active');
		$('.logo').toggleClass('color');
	});

	// Drop down
	$("ul.menu > li").hover(function () {
	    $('body').toggleClass('hover-active');
	 });

	// Accordion
	$('.accordion .title').click(function() {
		$(this).next('ul').slideToggle();
		$(this).toggleClass('on');
	});

		$('.back-top').click(function() {
      $('html, body').animate({
        	scrollTop: $("body").offset().top
    		}, 900);
      });

	// Add class to secondary menu if list items exist
	if( ($("ul#sec-nav").has("li").length === 0) ) {
		$("ul#sec-nav").hide();
	} else {
	  //$("ul#sec-nav").addClass('py-12');
	}

	$(".datepicker" ).datepicker({
			dateFormat : "yy-mm-dd",
			changeYear: true,
			changeMonth: true
	});

	// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        }); 
      }
    }
  });

  // Add class if total item is less than 4
  $('.slick-track').each(function() {
  	var totalItem = $(this).children().length;
  	if (totalItem < 4) {
  		$('.slick-track').addClass('on');
  	}
  });
  
  


	/**
	* jquery.matchHeight-min.js v0.5.2
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/
	(function(b){b.fn.matchHeight=function(a){if("remove"===a){var d=this;this.css("height","");b.each(b.fn.matchHeight._groups,function(b,a){a.elements=a.elements.not(d)});return this}if(1>=this.length)return this;a="undefined"!==typeof a?a:!0;b.fn.matchHeight._groups.push({elements:this,byRow:a});b.fn.matchHeight._apply(this,a);return this};b.fn.matchHeight._apply=function(a,d){var c=b(a),e=[c];d&&(c.css({display:"block","padding-top":"0","padding-bottom":"0","border-top-width":"0","border-bottom-width":"0",
	height:"100px"}),e=k(c),c.css({display:"","padding-top":"","padding-bottom":"","border-top-width":"","border-bottom-width":"",height:""}));b.each(e,function(a,c){var d=b(c),e=0;d.each(function(){var a=b(this);a.css({display:"block",height:""});a.outerHeight(!1)>e&&(e=a.outerHeight(!1));a.css({display:""})});d.each(function(){var a=b(this),c=0;"border-box"!==a.css("box-sizing")&&(c+=g(a.css("border-top-width"))+g(a.css("border-bottom-width")),c+=g(a.css("padding-top"))+g(a.css("padding-bottom")));
	a.css("height",e-c)})});return this};b.fn.matchHeight._applyDataApi=function(){var a={};b("[data-match-height], [data-mh]").each(function(){var d=b(this),c=d.attr("data-match-height");a[c]=c in a?a[c].add(d):d});b.each(a,function(){this.matchHeight(!0)})};b.fn.matchHeight._groups=[];b.fn.matchHeight._throttle=80;var h=-1,f=-1;b.fn.matchHeight._update=function(a){if(a&&"resize"===a.type){a=b(window).width();if(a===h)return;h=a}-1===f&&(f=setTimeout(function(){b.each(b.fn.matchHeight._groups,function(){b.fn.matchHeight._apply(this.elements,
	this.byRow)});f=-1},b.fn.matchHeight._throttle))};b(b.fn.matchHeight._applyDataApi);b(window).bind("load resize orientationchange",b.fn.matchHeight._update);var k=function(a){var d=null,c=[];b(a).each(function(){var a=b(this),f=a.offset().top-g(a.css("margin-top")),h=0<c.length?c[c.length-1]:null;null===h?c.push(a):1>=Math.floor(Math.abs(d-f))?c[c.length-1]=h.add(a):c.push(a);d=f});return c},g=function(a){return parseFloat(a)||0}})(jQuery);


	$('.equal').matchHeight();

})();
